// 导入Vue核心库
import Vue from 'vue'
// 导入Vue路由插件
import VueRouter from 'vue-router'
// 保存原始的路由push方法
const routerPush = VueRouter.prototype.push
// 重写路由push方法，捕获导航重复的异常
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

// 1111


// 安装VueRouter插件
Vue.use(VueRouter)

// 定义路由配置数组
const routes = [{
    path: '/',                                      // 首页路由
    name: 'Home',                                   // 路由名称
    component: () => import('@/views/home/Index'),  // 懒加载组件
  },
  {
    path: '/contact',                               // 联系我们页面
    name: 'contact',
    component: () => import('@/views/home/Contact.vue'),
  },
  {
    path: '/product',                               // 产品列表页面
    name: 'product',
    component: () => import('@/views/home/Product.vue'),
  },
  {
    path: '/productDetail/:id',                    // 产品详情页面，:id表示产品id
    name: 'productDetail',
    component: () => import('@/views/home/ProductDetail.vue'),
  },
  {
    path: '/process',                               // 流程页面
    name: 'process',
    component: () => import('@/views/home/Process.vue'),
  },
  {
    path: '/apply/:id?',                            // 申请页面，:id表示产品id
    name: 'apply',
    component: () => import('@/views/home/Apply.vue'),
  },
  {
    path: '/login',                                 // 用户登录页面
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
  },
  {
    path: '/forget',                                // 忘记密码页面
    name: 'Forget',
    component: () => import('@/views/login/Forget.vue'),
  },
  {
    path: '/register',                              // 用户注册页面
    name: 'Register',
    component: () => import('@/views/login/Register.vue'),
  },
  {
    path: '/admin/login',                           // 管理员登录页面
    name: 'AdminLogin',
    component: () => import('@/views/admin/Login.vue'),
    meta: {
      title: '管理员登录'                            // 页面标题
    }
  },
  {
    path: '/admin',                                 // 管理后台主路由
    name: '用户后台',
    redirect: '/admin/center',                      // 重定向到个人中心页面
    component: () => import('@/views/Admin.vue'),
    meta: {
      requireAuth: true                             // 需要身份验证
    },
    children: [{                                    // 嵌套子路由
        path: 'center',                             // 个人中心页面
        name: '个人中心',
        component: () => import('@/views/admin/Center.vue'),
        meta: {
          requireAuth: true,                        // 需要身份验证
          title: '个人中心'                          // 页面标题
        },
      },
      {
        path: 'user',                               // 用户信息管理页面
        name: '用户信息',
        component: () => import('@/views/admin/User.vue'),
        meta: {
          requireAuth: true,
          title: '用户信息'
        },
      },
      {
        path: 'city',                               // 城市信息管理页面
        name: '城市信息',
        component: () => import('@/views/admin/City.vue'),
        meta: {
          requireAuth: true,
          title: '城市信息'
        },
      },
      {
        path: 'subscribe',                          // 订阅信息管理页面
        name: '订阅信息',
        component: () => import('@/views/admin/Subscribe.vue'),
        meta: {
          requireAuth: true,
          title: '订阅信息'
        },
      },
      {
        path: 'product',                            // 产品信息管理页面
        name: '产品信息',
        component: () => import('@/views/admin/Product.vue'),
        meta: {
          requireAuth: true,
          title: '产品信息'
        },
      },
      {
        path: 'notice',                             // 公告信息管理页面
        name: '公告信息',
        component: () => import('@/views/admin/Notice.vue'),
        meta: {
          requireAuth: true,
          title: '公告信息'
        },
      },
    ]
  },
  {
    path: '*',                                      // 404页面，匹配所有未定义的路由
    name: '404',
    component: () => import('@/views/404'),
    meta: {
      title: '404'
    },
  },
]

// 创建路由实例
const router = new VueRouter({
  mode: 'history',                                  // 使用HTML5 History模式
  base: process.env.BASE_URL,                       // 应用的基路径
  routes                                            // 路由配置
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  window.document.title = to.meta.title == undefined ? '小微企业' : to.meta.title
  // 从localStorage获取用户和管理员的登录状态
  const isUserAuth = localStorage.getItem('isUserAuth')
  const isAdminAuth = localStorage.getItem('isAdminAuth')
  const token = localStorage.getItem('access_token')

  if (to.path === '/admim/login') {
    if (isAdminAuth && token) {
      next('/admin')                                // 管理员已登录则跳转到管理后台
    } else {
      next()                                        // 否则继续访问登录页
    }
  }
  
  // 客户端登录路由判断
  if (to.path === '/login') {
    if (isUserAuth && token) {
      next('/')                                     // 用户已登录则跳转到客户端首页
    } else {
      next()                                        // 否则继续访问登录页
    }
  }

  // 需要身份验证的路由判断
  if (to.meta.requireAuth) {
    if (!isAdminAuth) {
      next({
        path: '/admin/login',                       // 未登录则跳转到管理员登录页
        query: {
          redirect: to.fullPath                     // 保存原目标路径，便于登录后重定向
        }
      })
    } else {
      next()                                        // 已登录则允许访问
    }
  } else {
    next()                                          // 不需要验证的路由直接放行
  }
})

// 路由错误处理
router.onError((error) => {
  // 匹配"Loading chunk x failed"错误模式
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  // 如果是块加载失败，则重新加载当前路由
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

// 导出路由实例
export default router